import request from '../request'

export function fetchList(params) {
    return request({
        url: '/Api/News/getList',
        params,
    })
}

export function fetchDetail(params) {
    return request({
        url: '/Api/News/getDetail',
        params
    })
}